import React, { useEffect, useState } from "react";
import { getData } from "../../Tools/helpers";

import FormCustom from "../../components/FormCustom";
import TableCustom from "../../components/TableCustom";

const Career = () => {
  const [dataTable, setDataTable] = useState([]);
  const [dataForm, setDataForm] = useState({});
  const [isTrueUpdateData, setIsTrueUpdateData] = useState(false);
  const [isTrueDeleteData, setIsTrueDeleteData] = useState(false);
  const [listUniversities, setListUniversities] = useState([]);

  const FieldsCustom = [
    { name: "code", label: "Código", required: "true" },
    {
      name: "university_id",
      label: "Campus",
      required: "true",
      type: "select",
      list: listUniversities,
      field_select_description: "name",
    },
    { name: "name", label: "Nombre de la carrera", required: "true" },
    { name: "description", label: "Descripción breve", required: "false" },
  ];

  const FieldsCustomTable = [
    { name: "code", label: "Código" },
    {
      name: "univertity_name",
      label: "Campus",
    },
    { name: "name", label: "Nombre de la carrera" },
    { name: "description", label: "Descripción breve" },
  ];

  const routeForm = "Career";

  const getCareer = async () => {
    const route = routeForm;
    const send = await getData(route);
    if (send.code === 200) {
      setDataTable(send.data);
    }
  };

  const getUniversities = async () => {
    const route = "University";
    const send = await getData(route);
    if (send.code === 200) {
      setListUniversities(send.data);
    }
  };

  useEffect(() => {
    getUniversities();
    getCareer();
  }, []);

  return (
    <div className="flex-1">
      <div className=" mb-10 max-w-2xl">
        <FormCustom
          fields={FieldsCustom}
          title="DATOS DE CARRERAS"
          route={routeForm}
          method="post"
          setData={setDataForm}
          data={dataForm}
          fieldDialog="name"
          setIsTrueUpdateData={setIsTrueUpdateData}
          isTrueUpdateData={isTrueUpdateData}
          refreshDataList={getCareer}
          setIsTrueDeleteData={setIsTrueDeleteData}
          isTrueDeleteData={isTrueDeleteData}
        />
      </div>
      <div className="flex-1">
        <TableCustom
          fields={FieldsCustomTable}
          setDataForm={setDataForm}
          data={dataTable}
          setIsTrueUpdateData={setIsTrueUpdateData}
          setIsTrueDeleteData={setIsTrueDeleteData}
        />
      </div>
    </div>
  );
};

export default Career;
